import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=c06d8738&scoped=true&"
import script from "./Statuses.vue?vue&type=script&lang=js&"
export * from "./Statuses.vue?vue&type=script&lang=js&"
import style0 from "./Statuses.vue?vue&type=style&index=0&id=c06d8738&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d8738",
  null
  
)

export default component.exports